import { createForm } from '@seek/forms-ui';
import { QueryFilter, type DriverList } from './QueryFilter';

export interface FormValues {
  primaryDriver: string;
  secondaryDriver: string;
  // the type might need to be changed here
  primaryOptions: string;
  secondaryOptions: string;
}

const { FormProvider, useField } = createForm<FormValues>();
export { useField };

interface Props {
  driverList: DriverList;
  showDrawerFilter?: boolean;
}

export const QueryFilterForm = ({
  driverList,
  showDrawerFilter = false,
}: Props) => {
  const initialValues: FormValues = {
    primaryDriver: '',
    secondaryDriver: '',
    primaryOptions: '',
    secondaryOptions: '',
  };

  return (
    <FormProvider initialValues={initialValues}>
      {({ handleSubmit }) => (
        <QueryFilter
          driverList={driverList}
          handleSubmit={handleSubmit}
          showDrawerFilter={showDrawerFilter}
        />
      )}
    </FormProvider>
  );
};
